











































































































































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import reportModule from '@/store/modules/common/report.module';
import _ from 'lodash';
import { da } from 'date-fns/locale';

@Component({
  name: 'VOverallReport'
})
export default class VOverallReport extends Vue {
  public getCSIColor(index) {
    if (index / this.rpData.length >= 2 / 3)
      return 'background-color: rgb(192,0,1)';
    else if (index / this.rpData.length >= 1 / 3)
      return 'background-color: rgb(244,184,2)';
    return 'background-color: rgb(0,167,80)';
  }

  public getColor(item, column) {
    const data = [..._.orderBy(reportModule.reportData, [column], ['desc'])];
    let sum = 0
    const value = parseFloat(item[column])
    for (const idx in data) {
      sum += parseFloat(data[idx][column])
    }
    const avg = sum/data.length
    const topTier = 2/3 * avg / 0.5 
    const midTier = 1/3 * avg / 0.5 
    if (value >= topTier)
      return 'background-color: rgb(0,167,80)';
    else if (value >= midTier)
      return 'background-color: rgb(244,184,2)';
    return 'background-color: rgb(192,0,1); color: #fff';
  }

  get rpData() {
    return [
      ..._.orderBy(
        reportModule.reportData,
        ['coachingSuccessIndex(CSI)Score'],
        ['desc']
      )
    ];
  }
}
